class GradeService {
    constructor($http, $q) {
        let self = this;

        self.saveSubjectGrade = function(grade) {
            return $http.post('/api/grade/subject_area/' + grade.id, grade, {
                headers: {
                    'Content-Type': 'application/json',
                    'authentication': localStorage.getItem('kes_token')
                }
            }).then((res => res.data), (error) => $q.reject(error));
        };

        self.saveLearningGrade = function(grade) {
            return $http.post('/api/grade/learning_area/' + grade.id, grade, {
                headers: {
                    'Content-Type': 'application/json',
                    'authentication': localStorage.getItem('kes_token')
                }
            }).then((res => res.data), (error) => $q.reject(error));
        };

        self.createLearningGrade = function(grade) {
            return $http.post('/api/grade/learning_area', grade, {
                headers: {
                    'Content-Type': 'application/json',
                    'authentication': localStorage.getItem('kes_token')
                },
                data: {}
            }).then((res => res.data), (error) => $q.reject(error));
        };

        self.createSubjectGrade = function(grade) {
            return $http.post('/api/grade/subject_area', grade, {
                headers: {
                    'Content-Type': 'application/json',
                    'authentication': localStorage.getItem('kes_token')
                },
                data: {}
            }).then((res => res.data), (error) => $q.reject(error));
        };

        self.deleteLearningGrade = function(id) {
            return $http({
                method: 'DELETE',
                url: '/api/grade/learning_area/' + id,
                headers: {
                    'Content-Type': 'application/json',
                    'authentication': localStorage.getItem('kes_token')
                },
                data: {}
            }).then((res => res.data), (error) => $q.reject(error));
        };

        self.deleteSubjectGrade = function(id) {
            return $http({
                method: 'DELETE',
                url: '/api/grade/subject_area/' + id,
                headers: {
                    'Content-Type': 'application/json',
                    'authentication': localStorage.getItem('kes_token')
                },
                data: {}
            }).then((res => res.data), (error) => $q.reject(error));
        };
    }
}

export default GradeService;




// WEBPACK FOOTER //
// ./src/app/pages/evaluation/services/gradeService.js